export default{chipGroup:"w_7"};
